import billerVerifiedState from './billerVerifiedState.middleware';
import payerActiveState from './payerActiveState.middleware';
import pcrVerifiedState from './pcrVerifiedState.middleware';

const middlewares = [...billerVerifiedState, ...pcrVerifiedState, ...payerActiveState];

export default middlewares;
